import { api } from "@/api";
import { type ICitizenship } from "./types";

export const getCitizenships = () =>
  api
    .get<{ citizenships: ICitizenship[] }>(`/citizenships`)
    .then((r) => r.data.citizenships);

export const getDefaultCitizenshipCountry = () =>
  api.get<ICitizenship>(`/citizenships/country/default`).then((r) => r.data);
